import { useUrlSearchParams } from '@dai/common'
import React from 'react'

import { FeatureMessage } from '@/components/common/UpgradeMessage'
import { usePosDataSetupStatus } from '@/hooks/use-pos-data-setup-status'
import useT from '@/i18n/useT'

export const SalesCategorySettingsPanel: React.FC<{
  storeIds: string[] | undefined
}> = ({ storeIds }) => {
  const { t } = useT()

  const {
    handle: { handleNavTo },
  } = useUrlSearchParams()

  const {
    loading,
    hasDataInBigQuery,
    numUnlinkedStores,
    needToSetUpCategories,
  } = usePosDataSetupStatus({ storeIds })

  if (loading) {
    return null
  }

  if (!hasDataInBigQuery) {
    return (
      <FeatureMessage
        message={t('noSalesData.message')}
        buttonText={t('noSalesData.button')}
        onClick={() => handleNavTo('/admin/sales-data')}
      />
    )
  }

  if (numUnlinkedStores > 0) {
    return (
      <FeatureMessage
        message={t('unlinkedStores.message', {
          numUnlinkedStores,
        })}
        buttonText={t('unlinkedStores.button')}
        onClick={() => handleNavTo('/admin/sales-data')}
      />
    )
  }

  if (needToSetUpCategories) {
    return (
      <FeatureMessage
        message={t('setUpCategories.message')}
        buttonText={t('setUpCategories.button')}
        onClick={() => handleNavTo('/admin/sales-data')}
      />
    )
  }

  return null
}
